function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { lossy as _lossy, preserveTransparency as _preserveTransparency, progressive as _progressive } from "../../qualifiers/flag.js";
import { DeliveryAction } from "./DeliveryAction.js";
import { ProgressiveQualifier } from "../../qualifiers/progressive.js";
/**
 * @memberOf Actions.Delivery
 * @extends {Actions.Delivery.DeliveryAction}
 * @see Visit {@link Actions.Delivery|Delivery} for an example
 */

var DeliveryFormatAction = /*#__PURE__*/function (_DeliveryAction) {
  _inherits(DeliveryFormatAction, _DeliveryAction);

  var _super = _createSuper(DeliveryFormatAction);

  function DeliveryFormatAction(deliveryKey, deliveryType) {
    _classCallCheck(this, DeliveryFormatAction);

    return _super.call(this, deliveryKey, deliveryType, 'formatType');
  }
  /**
   * @description Uses lossy compression when delivering animated GIF files.
   * @return {this}
   */


  _createClass(DeliveryFormatAction, [{
    key: "lossy",
    value: function lossy() {
      this._actionModel.lossy = true;
      this.addFlag(_lossy());
      return this;
    }
    /**
     * @description Uses progressive compression when delivering JPG file format.
     * @return {this}
     */

  }, {
    key: "progressive",
    value: function progressive(mode) {
      if (mode instanceof ProgressiveQualifier) {
        this._actionModel.progressive = {
          mode: mode.getFlagValue()
        };
        this.addFlag(mode);
      } else {
        this._actionModel.progressive = {
          mode: mode
        };
        this.addFlag(_progressive(mode));
      }

      return this;
    }
    /**
     * @description Ensures that images with a transparency channel are delivered in PNG format.
     */

  }, {
    key: "preserveTransparency",
    value: function preserveTransparency() {
      this._actionModel.preserveTransparency = true;
      this.addFlag(_preserveTransparency());
      return this;
    }
  }], [{
    key: "fromJson",
    value: function fromJson(actionModel) {
      var formatType = actionModel.formatType,
          lossy = actionModel.lossy,
          progressive = actionModel.progressive,
          preserveTransparency = actionModel.preserveTransparency;
      var result;

      if (formatType) {
        result = new this('f', formatType);
      } else {
        result = new this('f');
      }

      if (progressive) {
        if (progressive.mode) {
          result.progressive(progressive.mode);
        } else {
          result.progressive();
        }
      }

      lossy && result.lossy();
      preserveTransparency && result.preserveTransparency();
      return result;
    }
  }]);

  return DeliveryFormatAction;
}(DeliveryAction);

export { DeliveryFormatAction };